import type { CoreSegmentEvent } from '@segment/analytics-core';
import type { Plugin } from '@segment/analytics-next';

function addScreenSizeToContext(event: CoreSegmentEvent) : void {
  const screenData = {
    width: screen.width,
    height: screen.height
  };

  if (event.context === undefined) {
    event.context = {
      screen: screenData
    };
  } else {
    event.context.screen = screenData;
  }
}

const screenSizePlugin : Plugin = {
  name: 'screenSizePlugin',
  version: '1.0.0',
  type: 'enrichment',

  isLoaded() {
    return true;
  },

  async load() {
    // No-op: plugin setup is synchronous
  },

  page(context) {
    addScreenSizeToContext(context.event);

    return context;
  },

  track(context) {
    addScreenSizeToContext(context.event);

    return context;
  }
};

export {
  screenSizePlugin
};
